import { useEffect } from "react";
import { EXPENSE_SETUP } from "../../api/allApi_List";
import AddExpense from "../../components/expense/add/AddExpense";
import useGetData from "../../CustomHooks/useAxios/useGetData";
import DialogBox from "../../components/UI/DialogBox";
import spin from "../../assets/icons/spin.png";
import { handleErrMessage } from "../../functions/handleErrMessage";
import { Add_EXPENSE } from "../../api/allApi_List";
import usePostData from "../../CustomHooks/useAxios/usePostData";
import MainPageLayout from "../../layout/MainPageLayout";
import { prepareFormData } from "../../functions/prepareFormData";

const AddExpensePage = () => {
  const { data, isLoaded, error, getData } = useGetData();
  const { executePost, loading, successResponse, formError, setFormError } =
    usePostData();

  useEffect(() => {
    getData(EXPENSE_SETUP);
  }, []);

  // execute post api
  const sendData = async (data, reset) => {
    // send data into form data
    const formData = prepareFormData(data);
    //API calling
    executePost(formData, Add_EXPENSE, reset);
  };

  return (
    <MainPageLayout headerConfig={{ title: "Add Expense" }}>
      {isLoaded && !error ? (
        <AddExpense
          sendData={sendData}
          expenseSetup={data}
          loading={loading}
          successResponse={successResponse}
        />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
      {formError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(formError)}
          closeAction={() => setFormError("")}
        />
      )}
    </MainPageLayout>
  );
};
export default AddExpensePage;
